import React, {useEffect, useState} from "react";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import axios from "axios";
import {config} from "../../Helpers/env";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {dateConvert} from "../Utils/ConvertDate";
import {Link} from "react-router-dom";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {useDebounce} from "../Lab/useDebounce";
import {DoctorDateFilter, Progress} from "../DoctorsModule/WaitingList";
import {FinishedStatus, PendingStatus} from "../DoctorsModule/doctorStyles";
import {ReusableRouteTabs} from "../Utils/Dialogs/ReusableTabs";
import {history} from "../../Helpers/history";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl.', hidden: false},
    {id: 'date', numeric: false, disablePadding: false, label: 'Date', hidden: false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.', hidden: false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name', hidden: false},
    {id: 'phone_no', numeric: false, disablePadding: false, label: 'Phone ', hidden: false},
    {id: 'kin_phone_no', numeric: false, disablePadding: false, label: 'NOK Phone', hidden: false},
    {id: 'doctor_name', numeric: false, disablePadding: false, label: 'Doctor Name', hidden: false},
    {id: 'visit_department', numeric: false, disablePadding: false, label: 'Visit Department', hidden: false},
    {id: 'risk_factor', numeric: false, disablePadding: false, label: 'Risk Factor', hidden: false},
    {id: 'status', numeric: false, disablePadding: false, label: 'Status', hidden: false},
    {id: 'action', numeric: false, disablePadding: true, label: 'Action', hidden: false},
];

const components = [
    {label: 'Active Patients',     path: '/gyn-and-obs-waiting-list'},
    {label: 'Missed Appointments', path: '/gyn-missed-appointments'},
    {label: 'Delivered Mothers',   path: '/gyn-delivered-mothers'},
    {label: 'High Risk Mothers',   path: '/gyn-high-risk-mothers'},
    {label: 'Emergency Patients',  path: '/gyn-emergency-patients'},
];


const GynHighRiskMothers = ({actions, snackbars}) => {

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const department_id = !_token.department_id ? "" : _token.department_id;

    const [date, setDate] = useState({start_date: dateConvert(), end_date: dateConvert()});
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({waitingList: [], loading: 'idle', total: 0});
    const [activePage, setActivePage] = useState(1);
    const [debouncedInputValue] = useDebounce(searchValue, 500);

    const {loading, total, waitingList} = data;
    const {start_date, end_date} = date;

    useEffect(() => {
        const formData = new FormData();
        formData.append('search', debouncedInputValue);
        formData.append('start_date', start_date);
        formData.append('end_date', end_date);
        formData.append('department_id', department_id);
        formData.append('per_page', rowsPerPage);
        setData({...data, loading: 'pending'});
        axios.post(`${config.smsUrl}/cdoctor/gyn_high_risk_mothers/${activePage}`, formData).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = dt.waiting_list ? dt.waiting_list : [];
            const total_count = dt.total_count ? dt.total_count : 0;
            const items = arr.map((item, index) => {
                const status = {
                    2: <PendingStatus>Pending</PendingStatus>,
                    3: <Progress>Treatment ongoing</Progress>,
                    4: <FinishedStatus>Complete</FinishedStatus>
                }
                return {
                    ...item,
                    count: ((activePage - 1) * rowsPerPage) + index + 1,
                    date: item.begin_datetime,
                    patient_number: item.patient_number,
                    patient_name: `${!item.first_name ? "" : item.first_name} ${!item.last_name ? "" : item.last_name}`,
                    doctor_name: `${item.doctor_first_name} ${item.doctor_last_name}`,
                    status: status[item.status],
                    action: (
                        <Link to={{pathname: `/gyn-and-obs-dashboard/${item.patient_number}/${item.visit_id}/1`}}>
                            <button type='button' className='btn btn-sm small-btn sms-info-btn'>View</button>
                        </Link>
                    )
                }
            });
            setData({...data, loading: 'success', waitingList: items, total: total_count});
        }).catch((err) => {
            setData({...data, loading: 'error'});
            logoutErrorMessage(err, null, actions);
        });
    }, [debouncedInputValue, activePage, rowsPerPage, start_date, end_date]);

    const handleChangeDate = (event) => {
        const {value, name} = event.target;
        setDate({...date, [name]: value});
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setActivePage(1);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const handleChangeNextPage = (value) => {
        setActivePage(value);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isRejected = loading === 'error';

    const {headCells, all_hidden, handleAllHeadCells, handleHeadCells} = useHiddenColumns(headData);

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div data-testid="gyn-high-risk-mothers" className='journals'>
            <PageTitle title='Gyn High Risk Mothers'/>
            <SubHeader title="Gyn and Obs" subTitle='High Risk Mothers'>
                <div className="header-icon-margin-right-zero">
                    <img src="/images/antenatal-blue.png"
                         className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>
            <div className="mui-tables">
                <div className="row mb-0">
                    <div className="col-lg-8">
                        <DoctorDateFilter {...{state: date, handleChange: handleChangeDate}}/>
                    </div>
                </div>
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <CustomTable title="High Risk Mothers" customPage
                             handleChangeNextPage={handleChangeNextPage}
                             headData={headCells} handler={handleSearch} records={10} total_count={total}
                             activePage={activePage} data={waitingList} colSpan={5} term={searchValue}
                             handleHeadCells={handleHeadCells} all_hidden={all_hidden}
                             handleAllHeadCells={handleAllHeadCells} pagination={pagination}>
                    <TableBody>
                        {isLoading ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">
                                <img src="/images/smsloader.gif" alt="loader"/>
                            </TableCell>
                        </TableRow> : null}
                        {isSuccess ? waitingList.length > 0 ? waitingList.slice(0, rowsPerPage)
                            .map((item, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1}
                                          key={index} className='mui-table-row'>
                                    {headCells.map((head) => (
                                        <TableCell key={head.id}
                                                   hidden={head.hidden}>{item[head.id]}</TableCell>
                                    ))}
                                </TableRow>
                            )) : <TableRow>
                            <TableCell colSpan={headCells.length} align="center">No records found</TableCell>
                        </TableRow> : null}
                        {isRejected ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">The server did not return a
                                valid response</TableCell>
                        </TableRow> : null}
                    </TableBody>
                </CustomTable>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar};
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}};
}

export default connect(mapStateToProps, mapDispatchToProps)(GynHighRiskMothers);